import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { EntityType } from '@beefco/types/bridge';
import { BeefCoExtContext } from '@beefco/sdk-shared';
import { findDOMNode } from "./findDomNode";
/**
 * Responsibilities:
 * 1. attach events on mount (unmount does not require);
 * 2. modify node attributes
 * 2. throw mount / unmount events;
 * 3. handle drag events;
 */
// TODO: change to hook if possible?
export var Outer = /*#__PURE__*/function (_React$Component) {
  _inherits(Outer, _React$Component);
  var _super = _createSuper(Outer);
  function Outer() {
    var _this;
    _classCallCheck(this, Outer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", _this.upgradeDOMNode.bind(_assertThisInitialized(_this)));
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", _this.upgradeDOMNode.bind(_assertThisInitialized(_this)));
    // FIXME: @babel/preset-typescript requires flag allowDeclareFields to be true for this to work
    // declare context: React.ContextType<typeof BeefCoExtContext>;
    _defineProperty(_assertThisInitialized(_this), "domElement", void 0);
    return _this;
  }
  _createClass(Outer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var globalBridge = this.getGlobalBridge();
      // FIXME: имеет смысл избежать ситуации, где globalBridge не инициализирован:
      //  - либо инициализировать его синхронно, навешивая слушатели на promise
      //  - либо отрисовывать страницу после инициализации
      //  - либо складывать события в очередь и применять после доступности
      if (!globalBridge) return;
      globalBridge.unregister(EntityType.NODE, this.domElement);
    }
  }, {
    key: "getGlobalBridge",
    value: function getGlobalBridge() {
      var _this$context;
      return ((_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.globalBridge) || null;
    }
  }, {
    key: "getDOMNode",
    value: function getDOMNode() {
      if (document.body.contains(this.domElement)) return this.domElement;

      // eslint-disable-next-line react/no-find-dom-node
      var domNode = findDOMNode(this);
      // Used to be this check: !domNode || domNode.nodeType !== 1
      /** In case element is empty or not an HTMLElement */
      if (domNode instanceof HTMLElement) return domNode;
      return undefined;
    }
  }, {
    key: "upgradeDOMNode",
    value: function upgradeDOMNode() {
      var _this$props = this.props,
        nodeId = _this$props.nodeId,
        uniqueId = _this$props.uniqueId;
      var globalBridge = this.getGlobalBridge();
      if (!globalBridge || document.body.contains(this.domElement)) return;
      var domElement = this.getDOMNode();
      globalBridge.unregister(EntityType.NODE, this.domElement);
      if (!domElement) return;
      this.domElement = domElement;
      globalBridge.register(EntityType.NODE, this.domElement, {
        nodeId: nodeId,
        uniqueId: uniqueId
      });
      if (this.domElement.tagName === 'A') {
        this.domElement.removeAttribute('href');
        this.domElement.style.cursor = 'default';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);
  return Outer;
}(React.Component);
Outer.contextType = BeefCoExtContext;